// 3rd Party
import _ from 'lodash';

// Exports
export const convertStringToNumber = e => {
  const convertedValue = parseInt(e.currentTarget.value);
  return Number.isNaN(convertedValue) ? '' : convertedValue;
};

export const formatPhoneNumber = phoneNumber =>
  (phoneNumber && phoneNumber.length > 10
    ? phoneNumber.substring(2)
    : phoneNumber);

export const getInsuranceServiceData = (
  patient,
  requestedAppointment,
  matchId,
) => {
  if (!patient) {
    return null;
  }

  const doctor = _.get(requestedAppointment, 'provider.doctor');

  const data = {};
  if (_.get(patient, 'metadata.primaryInsuranceMember') === false) {
    data.firstName = _.get(patient, 'metadata.memberFirstName');
    data.lastName = _.get(patient, 'metadata.memberLastName');
    data.dob = _.get(patient, 'metadata.memberDateOfBirth');
  } else {
    data.firstName = _.get(patient, 'firstName');
    data.lastName = _.get(patient, 'lastName');
    data.dob = _.get(patient, 'dateOfBirth');
  }

  data.insuranceProviderName = _.get(
    patient,
    'metadata.wizardData.insurance.provider',
  );
  data.insuranceProviderState = _.get(
    patient,
    'metadata.wizardData.location.address.administrative_area_level_1',
  );
  data.matchId = matchId;
  data.npi = doctor ? doctor.npi : undefined;
  data.doctorName = doctor ? doctor.name : undefined;

  return data;
};

export const patientFormValidation = values => ({
  email: {
    value: values.email,
    errors: [new Error('')],
  },
  firstName: {
    value: values.firstName,
    errors: [new Error('')],
  },
  lastName: {
    value: values.lastName,
    errors: [new Error('')],
  },
  birthMonth: {
    value: values.birthMonth,
    errors: [new Error('')],
  },
  birthDay: {
    value: values.birthDay,
    errors: [new Error('')],
  },
  birthYear: {
    value: values.birthYear,
    errors: [new Error('')],
  },
  memberFirstName: {
    value: values.memberfirstName,
    errors: [new Error('')],
  },
  memberLastName: {
    value: values.memberlastName,
    errors: [new Error('')],
  },
  memberBirthMonth: {
    value: values.memberbirthMonth,
    errors: [new Error('')],
  },
  memberBirthDay: {
    value: values.memberbirthDay,
    errors: [new Error('')],
  },
  memberBirthYear: {
    value: values.memberbirthYear,
    errors: [new Error('')],
  },
});
